import { ShieldCheck } from 'lucide-react';

import { PageLayout } from '@/components/shared/PageLayout';
import { PageHeader } from '@/components/shared/PageHeader';
import { useTranslation } from '@/hooks/useTranslation';
import { InfluxConfigCard } from '../components/InfluxConfigCard';

export function BackendConfigPage() {
  const { t } = useTranslation();

  return (
    <PageLayout contentClassName="max-w-4xl">
      <PageHeader
        label={{ icon: ShieldCheck, text: t('backendConfig.badge') }}
        title={t('backendConfig.title')}
        description={t('backendConfig.description')}
      />

      <div className="flex flex-col gap-6">
        <InfluxConfigCard />
      </div>
    </PageLayout>
  );
}
